import store from '@/store/'

export default async (to, from, next) => {
	if (!store.getters.apiToken) {
		next({ name: 'Login' })
	} else next()
}
